import { render, staticRenderFns } from "./Zx.vue?vue&type=template&id=942dc386&scoped=true&"
import script from "./Zx.vue?vue&type=script&lang=js&"
export * from "./Zx.vue?vue&type=script&lang=js&"
import style0 from "./Zx.vue?vue&type=style&index=0&id=942dc386&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942dc386",
  null
  
)

export default component.exports